/**
 * Copies controller model data without losing class prototypes or invoking getters.
 */
export function deepCopy(value, copies = new WeakMap()) {
    if (value === null || typeof value !== "object") {
        return value;
    }
    if (copies.has(value)) {
        return copies.get(value);
    }
    const copy = value instanceof Date ? new Date(value.getTime())
        : value instanceof Map ? new Map()
            : value instanceof Set ? new Set()
                : Array.isArray(value) ? []
                    : Object.create(Object.getPrototypeOf(value));
    copies.set(value, copy);
    if (value instanceof Map && copy instanceof Map) {
        for (const [key, entry] of value) {
            copy.set(deepCopy(key, copies), deepCopy(entry, copies));
        }
    }
    else if (value instanceof Set && copy instanceof Set) {
        for (const entry of value) {
            copy.add(deepCopy(entry, copies));
        }
    }
    for (const key of Reflect.ownKeys(value)) {
        const descriptor = Object.getOwnPropertyDescriptor(value, key);
        if ("value" in descriptor) {
            descriptor.value = deepCopy(descriptor.value, copies);
        }
        Object.defineProperty(copy, key, descriptor);
    }
    return copy;
}
